import React from 'react'
import result from './images/result-image.png'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import '../App.css' // Keep for gradient classes

export default function Results() {
  const { ref, inView } = useInView({
    triggerOnce: true , 
    threshold: 0.3,
  })

  return (
    <div className="container-fluid py-5 result-container text-white">
      <h1 className="text-center gradient-text mb-5">Assured Results with MDQ PMS</h1>

      <div className="row align-items-center justify-content-between px-3">
        {/* Left Column: Text */}
        <div className="col-md-5">
          <ul className="list-unstyled">
            <li className="mb-3 text-warning">
              25–50% Efficiency Boost:{' '}
              <span className="text-light">Reduce delays, increase output, and eliminate manual errors.</span>
            </li>
            <li className="mb-3 text-warning">
              Zero Dependency:{' '}
              <span className="text-light">Built to work with your team – no technical expertise needed to manage.</span>
            </li>
            <li className="mb-3 text-warning">
              Real-Time Visibility:{' '}
              <span className="text-light">Get instant updates across production, sales, and dispatch.</span>
            </li>
            <li className="mb-3 text-warning">
              Up to 30% Cost Savings:{' '}
              <span className="text-light">Optimize resource use, track inventory in real-time, and cut wastage.</span>
            </li>
            <li className="mb-3 text-warning">
              Custom-Fit to Your Needs:{' '}
              <span className="text-light">Choose only the modules you need – no excess, no fluff.</span>
            </li>
          </ul>
        </div>

        {/* Right Column: Image with animation */}
        <div className="col-md-7 text-center">
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 80 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.0, delay: 0.3, ease: 'easeOut' }}
          >
            <img src={result} alt="Results Illustration" className="img-fluid" />
          </motion.div>
        </div>
      </div>
    </div>
  )
}

